<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.groups', 2),
                        href: meta.links.group_index,
                    },
                    {
                        name: group.name,
                        href: meta.links.group_show,
                    },
                    {
                        name: $tc('messages.factions', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="w-full flex space-x-4 justify-end">
            <AppButton :href="meta.links.edit">
                {{ $t('messages.edit') }}
            </AppButton>
        </div>

        <AppWell class="mt-5">
            <div v-for="faction in factions" :key="faction.id">
                <AppCard class="mt-3">
                    <div class="md:grid md:grid-cols-3 md:gap-6 p-4">
                        <div class="sm:flex gap-x-4 items-center">
                            <div>
                                <div>{{ faction.name }}</div>
                                <img
                                    :src="faction.image_path"
                                    v-if="faction.image_path"
                                    alt="faction image"
                                    class="h-10 sm:h-20 object-contain"
                                />
                            </div>
                            <div>
                                <p class="whitespace-pre-line italic text-sm text-gray-600">
                                    {{ faction.description }}
                                </p>
                            </div>
                        </div>
                        <div class="col-span-2">
                            <div class="flex -space-x-1 flex-wrap">
                                <div
                                    class="flex shrink-0 -space-x-1 bg-white rounded-xl p-1"
                                    v-for="student in faction.students"
                                    :key="student.id"
                                >
                                    <img
                                        :src="student.avatar_or_default"
                                        alt=""
                                        :title="student.full_name"
                                        class="max-w-none h-8 w-8 rounded-full ring-2 ring-white"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </AppCard>
            </div>
        </AppWell>

        <div v-if="students.length" class="mt-5">
            <div>
                {{ $t('messages.without_faction') }}
            </div>
            <div>
                <div class="flex -space-x-1 flex-wrap">
                    <div
                        class="flex shrink-0 -space-x-1 bg-white rounded-xl p-1"
                        v-for="student in students"
                        :key="student.id"
                    >
                        <img
                            :src="student.avatar_or_default"
                            alt=""
                            :title="student.full_name"
                            class="max-w-none h-8 w-8 rounded-full ring-2 ring-white"
                        />
                    </div>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppWell from '@/Shared/AppWell.vue';
import AppCard from '@/Shared/AppCard.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        AppButton,
        AppCard,
        AppWell,
        PanelPage,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'students', 'factions', 'group'],
};
</script>
